<template>
  <div>
    <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
      <div>
        <a-alert
          message="Code is not dupicate / Mã không được trùng"
          type="warning"
        />
        <br />
        <a-form-model ref="form" :model="form" :rules="rules">
          <a-form-model-item has-feedback label="Title / Tiêu đề" prop="title">
            <a-input v-model="form.title" placeholder="Enter text" />
          </a-form-model-item>
          <a-form-model-item has-feedback label="Code" prop="code">
            <a-input v-model="form.code" placeholder="Enter text" />
          </a-form-model-item>
        </a-form-model>
        <a-divider orientation="left">
          Information
        </a-divider>
        <a-descriptions :column="1">
          <a-descriptions-item label="Created by">
            {{ form.author && (form.author.fullname || form.author.username) }}
          </a-descriptions-item>
          <a-descriptions-item label="Created at">
            {{ form.createdAt | formatDateHour }}
          </a-descriptions-item>
          <a-descriptions-item label="Updated at">
            {{ form.updatedAt | formatDateHour }}
          </a-descriptions-item>
        </a-descriptions>

        <div
          style="text-align: right;"
          :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
          }"
        >
          <a-popconfirm
            title="Confirm action ?"
            ok-text="Delete"
            cancel-text="Close"
            @confirm="deleteItem"
          >
            <a-button
              style="margin-right: 5px; float: left;"
              icon="delete"
              :loading="loadingDelete"
              type="danger"
            >
              Delete
            </a-button>
          </a-popconfirm>

          <a-button
            @click="closeDrawerUpdate"
            style="margin-right: 5px;"
            icon="close"
          >
            Close
          </a-button>
          <a-button
            type="primary"
            @click="updateItem"
            :loading="loadingUpdate"
            icon="edit"
          >
            Update
          </a-button>
        </div>
      </div>
    </a-skeleton>
  </div>
</template>
<script>
import queryItem from "../data/queryItem";
export default {
  components: {},
  props: {
    updateOnView: {
      type: Function,
      default: null,
    },
    deleteOnView: {
      type: Function,
      default: null,
    },
    closeDrawerUpdate: {
      type: Function,
      default: null,
    },
    itemId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      checkItem: true,
      loading: true,
      loadingUpdate: false,
      loadingDelete: false,

      form: {
        name: null,
        userIds: [],
      },
      rules: {
        title: [
          {
            required: true,
            message: "Required / Tên không được bỏ trống",
            trigger: "change",
          },
        ],
        code: [
          {
            required: true,
            message: "Required / Tên không được bỏ trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    getItem() {
      this.loading = true;
      this.$apollo
        .query({
          fetchPolicy: "no-cache",
          query: queryItem.queryGet,
          variables: {
            id: this.itemId,
          },
        })
        .then(({ data }) => {
          if (data?.getParcelType) {
            this.form = { ...data.getParcelType };
            this.loading = false;
          }
        })
        .catch((error) => {
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
        });
    },
    updateItem() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingUpdate = true;
          this.$apollo
            .mutate({
              mutation: queryItem.queryUpdate,
              variables: {
                ...this.form,
                id: this.itemId,
                mainShiftId: this.form.mainShiftId || null,
              },
            })
            .then(({ data }) => {
              if (data?.updateParcelType) {
                this.$notification.success({
                  message: "Success",
                  description: "Updated Success!",
                });

                this.closeDrawerUpdate();
                this.updateOnView(data.updateParcelType);
              }
              this.loadingUpdate = false;
            })
            .catch((error) => {
              this.$notification.error({
                message: "Error",
                description: "Updated Error!",
              });
              this.loadingUpdate = false;
            });
        }
      });
    },
    deleteItem() {
      this.loadingDelete = true;
      this.$apollo
        .mutate({
          mutation: queryItem.queryDelete,
          variables: {
            id: this.itemId,
          },
        })
        .then(({ data }) => {
          if (data?.deleteParcelType) {
            this.$notification.success({
              message: "Success",
              description: "Deleted Success!",
            });

            this.closeDrawerUpdate();
            this.deleteOnView(data.deleteParcelType);
          }
          this.loadingDelete = false;
        })
        .catch((error) => {
          this.$notification.error({
            message: "Error",
            description: "Deleted Error!",
          });
          console.log("Xóa chức vụ không thành công", error);
          this.loadingDelete = false;
        });
    },
  },

  created() {
    this.getItem();
  },
};
</script>
<style></style>
